"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function uniqInsert(array, start, item) {
    var index = array.indexOf(item);
    if (index !== -1) {
        array.splice(index, 1);
    }
    array.splice(start, 0, item);
}
exports.uniqInsert = uniqInsert;
function uniqPush(array, item) {
    uniqInsert(array, array.length, item);
    return array.length;
}
exports.uniqPush = uniqPush;
